<template>
  
  <video id="home-video"  style="width: 100%" class="elementor-video"  autoplay="autoplay" :src="require('/public/file/FINDPOP_display.mp4')" poster="" paused="true"  loop="" muted="muted" playsinline="" controlslist="nodownload"></video>

</template>

<script setup>

</script>

<style>

</style>